import React, {Component} from "react";
import moment from "moment";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import {Buffer} from "buffer";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Form, Col, Row, Divider, Transfer, Button, DatePicker, Modal, Select, Spin} from "antd";
import {CreateDeliveryOrderStates} from "./types/CreateDeliveryOrderTypes";
import {orderApiService} from "../../services/otodis/OrderApiService";
import {CloudSyncOutlined, SaveOutlined} from "@ant-design/icons";
import SelectDriver from "../../components/selects/SelectDriver";
import SelectDeliveryVehicle from "../../components/selects/SelectDeliveryVehicle";
import {orderService} from "../../services/otodisApi/OrderService";

export interface CreateDeliveryOrderProps {
}

class CreateDeliveryOrder extends Component<CreateDeliveryOrderProps & any, CreateDeliveryOrderStates> {
    private readonly initState!: CreateDeliveryOrderStates;
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
    private token = new Cookies().get("_t");

    constructor(props: (CreateDeliveryOrderProps & any) | any) {
        super(props);
        const finalDealerCode = props?.match?.params?.dealerCode?.replace(/-/g, '#');
        const cookies = new Cookies();
        const dealer = JSON.parse(Buffer.from(cookies.get("_d"), "base64").toString());
        const dealerOption = [];
        for (const item of dealer) {
            dealerOption.push(item.DealerCode + " | " + item.DealerName);
        }
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            companyCode: companyCode,
            submitting: false,
            loading: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
            mockData: [],
            targetKeys: [],
            driverCode: "",
            driverName: "",
            driverEmail: "",
            assetCode: "",
            assetName: "",
            filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
            filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
            dealerOption: dealerOption,
            dealerSelected: [],
            finalLoadingModal: false,
        };
        this.state = {...this.initState};
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
        });
    };

    onWarehouseStartDate = (data: any) => {
        this.setState({
            filterStartDate: data,
        });
    };

    onWarehouseEndDate = (data: any) => {
        this.setState({
            filterEndDate: data,
        });
    };

    onSubmit = async () => {
        if (!this.state.assetCode || !this.state.driverCode || this.state.targetKeys.length < 1) {
            Modal.error({
                title: "Proses Gagal",
                content: "Mohon Lengkapi Data Anda",
            });
            return false;
        }

        await this.promisedSetState({
            submitting: true,
            finalLoadingModal: true,
        });

        const deliveryMethod = "AMREN";
        const listOrder = this.state.targetKeys.map((key: string) => {
            const dealerCode = key.slice(0, -17).replace("ORD", "DLR");

            return {
                dealer_code: dealerCode,
                order_code: key,
            };
        });

        const input = {
            delivery_method: deliveryMethod,
            driver_code: this.state.driverCode,
            driver_name: this.state.driverName,
            driver_email: this.state.driverEmail,
            delivery_license_plate: this.state.assetName,
            updated_by: this.user,
            list_order: listOrder,
        };
        // console.log(input);

        // return false;

        try {
            orderService.setToken(this.token);
            await orderService.deliveryManualMulti(input).then((dataInsert) => {
                Modal.success({
                    title: "Proses Sukses",
                    content: "Data berhasil diinput. " + dataInsert?.data.message,
                });

                let newSourceData = this.state.mockData.filter((e: any) => !this.state.targetKeys.includes(e.key));
                this.setState({
                    targetKeys: [],
                    mockData: newSourceData,
                    submitting: false,
                    finalLoadingModal: false,
                });
            });
        } catch (e: any) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda :" + e,
            });
            await this.promisedSetState({
                submitting: false,
                finalLoadingModal: false,
            });
        }
    };

    handleChange = (targetKeys: any) => {
        this.setState({targetKeys});
    };

    fetchOrderData = async () => {
        if (this.state.dealerSelected.length === 0) {
            Modal.error({
                title: "Error",
                content: "Silakan pilih dealer terlebih dahulu",
            });
            return false;
        }

        await this.promisedSetState({
            mockData: [],
            targetKeys: [],
        });

        const mockDataTemp: any = [];
        for (const dlrTemp of this.state.dealerSelected) {
            const dlr = dlrTemp.split(" | ")[0];
            await orderApiService
                .getOrder({
                    dealerCode: dlr,
                    dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
                    dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
                    dataType: "closing_date",
                    statusOrder: "CLOSED",
                })
                .then(async (value) => {
                    for (const item of value.data.data) {
                        const data = {
                            key: item.order_code,
                            title: item.order_code,
                            description: item.vehicle_engine_number + " | " + item.city_name + " - " + item.district_name + " - " + item.sub_district_name + " - " + item.customer_name,
                            vehicle_engine_number: item.vehicle_engine_number,
                            customer_name: item.customer_name,
                            full_address: item.city_name + " - " + item.district_name + " - " + item.sub_district_name,
                        };
                        mockDataTemp.push(data);
                    }
                    await this.promisedSetState({
                        mockData: mockDataTemp,
                    });
                })
                .catch((error) => {
                    console.error(`Error fetching data for dealer code: ${dlr}`, error);
                });
        }
    };

    onDriverChange = (data: any) => {
        this.setState({
            driverCode: data.value,
            driverName: data.children,
            driverEmail: data.email,
        });
    };

    onAssetChange = (data: any) => {
        this.setState({
            assetCode: data.value,
            assetName: data.children,
        });
    };

    handleChangeDealer = (targetKeys: any) => {
        this.setState({
            dealerSelected: targetKeys,
            mockData: [],
            targetKeys: [],
        });
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const filteredOptions = this.state.dealerOption.filter((o: any) => !this.state.dealerSelected.includes(o));
        return (
            <React.Fragment>
                <MainLayout
                    onChangeDealer={this.onDealerChange}
                    breadcrumbPath={`Delivery`}
                    breadcrumbMenu={`Buat Delivery Order`}
                    defaultSelectedKeys={["m-create-delivery"]}
                    defaultOpenKeys={["sm-delivery"]}
                >
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <Row>
                        <Col xs={24} xl={12}>
                            <div>
                                <Divider orientation="left">Dealer</Divider>
                                <Select mode="multiple" placeholder="Pilih Dealer" value={this.state.dealerSelected} onChange={this.handleChangeDealer} style={{width: "100%"}}>
                                    {filteredOptions.map((item: any) => (
                                        <Select.Option key={item} value={item}>{item}</Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    </Row>

                    <br/>

                    <Row>
                        <Col xs={24} xl={12}>
                            <div className={`mid-pad-10`} style={{}}>
                                <Divider orientation="left">Closed Order</Divider>
                                <Form layout={`inline`}>
                                    <Form.Item label="" className={"padTop-10"}>
                                        <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseStartDate(event)} format={"YYYY-MM-DD"}/>
                                    </Form.Item>
                                    <Form.Item label="" className={"padTop-10"}>
                                        <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseEndDate(event)} format={"YYYY-MM-DD"}/>
                                    </Form.Item>
                                    <Form.Item className={"padTop-10"}>
                                        <Button onClick={this.fetchOrderData} type="primary" icon={<CloudSyncOutlined/>}>
                                            {" "}
                                            Go{" "}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>
                        <Col xs={24} xl={12}>
                            <div style={{paddingLeft: "17px", paddingTop: "10px"}}>
                                <Divider orientation="left">List Pengiriman Order</Divider>
                                <Form layout={`inline`}>
                                    <Form.Item label="" style={{width: 200}} className={"padTop-10"}>
                                        {/* <AmrenDriverSelect onDriverChangeProps={this.onDriverChange} dealerCode={this.state.dealerSelected} value={this.state.driverCode}/> */}
                                        <SelectDriver onDriverChangeProps={this.onDriverChange} dealerCode={this.state.dealerSelected} value={this.state.driverCode}/>
                                    </Form.Item>
                                    <Form.Item label="" style={{width: 200}} className={"padTop-10"}>
                                        <SelectDeliveryVehicle onAssetChangeProps={this.onAssetChange} dealerCode={this.state.dealerSelected} value={this.state.assetCode}/>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>

                        <Col span={24} className={`pad-10`}>
                            <Transfer
                                dataSource={this.state.mockData}
                                showSearch
                                listStyle={{
                                    width: "100%",
                                    height: 580,
                                }}
                                targetKeys={this.state.targetKeys}
                                onChange={this.handleChange}
                                // render={item => `${item.title} | ${item.description}`}
                                render={(item) => (
                                    <div>
                                        <div>
                                            {item.title} | {item?.vehicle_engine_number}
                                        </div>
                                        <div>
                                            {item.customer_name} @ {item.full_address}
                                        </div>
                                    </div>
                                )}
                            />
                        </Col>

                        <Col span={24} className={`pad-10`}>
                            <Form.Item>
                                <Button type={"primary"} icon={<SaveOutlined/>} onClick={this.onSubmit} loading={this.state.submitting}>
                                    Simpan Data
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Modal visible={this.state.finalLoadingModal} closeIcon={true} footer={null}>
                        <div style={{textAlign: "center", padding: 20, minHeight: 100}}>
                            <Spin style={{marginTop: 20}} size={"large"} tip="Processing..."/>
                        </div>

                        <div style={{textAlign: "center", padding: 20}}>Mohon menunggu beberapa saat, kami sedang memproses permintaan anda.</div>
                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default withAuth(withRouter(CreateDeliveryOrder), 9);
